(function(){

  window.addEventListener('scroll', function () {
    const logo = document.querySelector('.header__heading-logo-wrapper');

    if (window.scrollY > 50) {
      logo.classList.add('active');
    } else {
      logo.classList.remove('active');
    }
  });

   const observer = new MutationObserver(() => {
    const marselloWidget = document.getElementById('marsello-widget');
    const marselloTab = document.getElementById('marsello-tab');

    if (marselloWidget && !marselloWidget.getAttribute('title')) {
      marselloWidget.setAttribute('title', 'Marsello Loyalty Rewards Widget');
    }

    if (marselloTab && !marselloTab.getAttribute('title')) {
      marselloTab.setAttribute('title', 'Marsello Loyalty Rewards Tab');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function updateTotalItems(inputEl) {
    // Get the parent quick-order-list
    const quickOrderList = inputEl.closest('quick-order-list');

    if (!quickOrderList) return;
 
    const inputs = quickOrderList.querySelectorAll('input[type="number"]');

    let total = 0;

    inputs.forEach(input => {
      total += parseInt(input.value, 10) || 0;
    });

    const totalEl = quickOrderList.querySelector('.quick-order-list__total-items');

    if (totalEl) {
      const numSpan = totalEl.querySelector('span') || totalEl;
      numSpan.textContent = total;
    }
    const removeAllBtn = quickOrderList.querySelector(
      'quick-order-list-remove-all-button, .quick-order-list-remove-all'
    );

    // if (removeAllBtn) {
    //   if (total > 0) {
    //     removeAllBtn.style.display = '';
    //     removeAllBtn.classList.remove('hidden');
    //   } else {
    //     removeAllBtn.classList.add('hidden');
    //   }
    // }
  }

  // Listen for changes
  document.addEventListener('change', (event) => {
    if (
      event.target.closest('quick-order-list') &&
      event.target.type === 'number'
    ) {
      updateTotalItems(event.target);
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.id === 'bulk-add-to-cart-btn' || 
        event.target.closest('#bulk-add-to-cart-btn')) {
      const btn = event.target.closest('#bulk-add-to-cart-btn');
   
      bulkAddToCart(btn);
    }
  });

  async function bulkAddToCart(btn) {

    // Parent wrapper
    const quickOrderList = btn.closest('quick-order-list');

    if (!quickOrderList) return;
 
    const inputs = quickOrderList.querySelectorAll(
      'input[type="number"]'
    ); 
    const items = [];

    inputs.forEach(input => {
      const qty = parseInt(input.value, 10) || 0;

      if (qty > 0) {

        const variantId =
          input.dataset.variantId ||
          input.closest('[data-variant-id]')?.dataset.variantId ||
          input.name?.replace('updates[]', '');

        if (variantId) {
          items.push({
            id: parseInt(variantId, 10),
            quantity: qty
          });
        }
      }
    });

    if (items.length === 0) {
      alert('Please enter a quantity for at least one variant.');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (res.ok) {

        btn.textContent = '✓ Added!';
        btn.style.background = '#235a49';

        // Optional cart refresh
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
 
        if (typeof openCart === 'function') {
          openCart();
        }
 
        inputs.forEach(input => {
          input.value = 0;
        });

        // Reset total display ONLY in current component
        const totalSpan = quickOrderList.querySelector(
          '.quick-order-list__total-items span'
        );

        if (totalSpan) {
          totalSpan.innerText = '0';
        }

        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);

      } else {

        const err = await res.json();

        alert(err.description || 'Something went wrong.');

        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }

    } catch (e) {

      btn.textContent = 'Error';
      btn.disabled = false;
    }
  }

  document.querySelectorAll('.ct2-card__add').forEach(function(btn) {
    btn.addEventListener('click', function() {
        const id = btn.dataset.productId;
       
        btn.innerText='Adding';
        btn.setAttribute('disabled','');

        fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
        }).then(() => {
        btn.textContent = '✓ Added';
        btn.style.background = '#16a34a';
        setTimeout(() => {
            btn.innerHTML = 'ADD 🛒';
            btn.style.background = '';
             btn.removeAttribute('disabled');
        }, 1500);
        });
    });
  });

  // Listen for any cart changes and update count
  document.addEventListener('DOMContentLoaded', async () => {
    // Patch fetch to detect cart/add.js calls
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const result = await originalFetch.apply(this, args);
      const url = args[0]?.toString() || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        // Clone response since it can only be read once
        result.clone().json().then(() => {
          fetch('/cart.js').then(r => r.json()).then(cart => {
            const count = cart.item_count;
            let bubble = document.querySelector('.cart-count-bubble');
            const cartLink = document.querySelector('#cart-icon-bubble');
            if (bubble) {
              const spans = bubble.querySelectorAll('span');
              if (spans) spans.forEach(span=>span.textContent = count);
            } else if (count > 0 && cartLink) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              bubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
              cartLink.appendChild(bubble);
            }
          });
        }).catch(() => {});
      }
      return result;
    };
  });

   
})();